module.exports = __webpack_public_path__ + "static/media/eleven.525b7125.jpg";